import ContainerCard from '../../../../common/components/ContainerCard';
// import { POSITION_OTHER_CODE, SPECIALTY_OTHER_CODE } from '../../../../constants';
import { IProfileContainer } from '../../../../models/Profile/IProfileContainer';
import styles from './ProfileReadMode.module.css';
import { format, parse } from 'date-fns';

type ProfileReadProps = {
  profileContainer: IProfileContainer;
  toggleEditMode: any; // function
};

const ProfileReadMode = (props: ProfileReadProps) => {
  const profile = props.profileContainer?.profileModel;
  const profileEditData = props.profileContainer?.profileEditModel;

  // const userDepartmentSize = profileEditData?.hrDeptSizes.find(
  //   x => x.value === profile?.hrDepartmentSize
  // )?.label;

  // archived const userSpecialty = profileEditData?.specialties.find(
  //   x => x.value === profile?.specialtyCode
  // )?.label;

  const primaryLanguage = profileEditData?.primaryLanguages.find(
    x => x.value === profile?.primaryLanguage
  )?.label;

  // const ethnicity = profileEditData?.ethnicities.find(x => x.value === profile?.ethnicity)?.label;

  // const gender = profileEditData?.genders.find(x => x.value === profile?.gender)?.label;

  const genderSex = profileEditData?.gcrGenderSexList.find(
    x => x.value === profile?.gcrGenderSex
  )?.label;

  const raceEthnicity = profileEditData?.gcrEthnicityRaceList.find(
    x => x.value === profile?.gcrEthnicityRace
  )?.label;

  const student = profileEditData?.gcrStudentList.find(x => x.value === profile?.gcrStudent)?.label;

  const hrInterests = profileEditData?.gcrJobFunctionList.filter(el =>
    profile.gcrHrInterest.includes(el.value)
  );

  const contentFormatPreferences = profileEditData?.gcrContentFormatPreferenceList.filter(el =>
    profile.gcrContentFormatPreference.includes(el.value)
  );

  const contentChannelPreferences = profileEditData?.gcrContentChannelPreferenceList.filter(el =>
    profile.gcrContentChannelPreference.includes(el.value)
  );

  const industry = profileEditData?.gcrIndustryList.find(
    x => x.value === profile?.gcrIndustry
  )?.label;

  const companysize = profileEditData?.gcrCompanySizeList.find(
    x => x.value === profile?.gcrCompanySize
  )?.label;

  const jobfunctionPrimary = profileEditData?.gcrJobFunctionList.find(
    x => x.value === profile?.gcrJobFunctionPrimary
  )?.label;

  const jobfunctionSecondary = profileEditData?.gcrJobFunctionList.filter(el =>
    profile.gcrJobFunctionSecondary.includes(el.value)
  );

  const joblevel = profileEditData?.gcrJobLevelList.find(
    x => x.value === profile?.gcrJobLevel
  )?.label;

  const userDirectReports = profileEditData?.directReportsNumbers.find(
    x => x.value === profile?.directReportsNumber
  )?.label;

  const academicMajor = profileEditData?.academicMajors.find(
    x => x.value === profile?.academicMajor
  )?.label;

  const creditTerm = profileEditData?.creditTerms.find(x => x.value === profile?.creditTerm)?.label;

  const enrollmentStatus = profileEditData?.enrollmentStatuses.find(
    x => x.value === profile?.enrollmentStatus
  )?.label;

  const educationLevel = profileEditData?.educationLevels.find(
    x => x.value === profile?.educationLevel
  )?.label;

  const supervisorsTitle = profileEditData?.supervisorPositions.find(
    x => x.value === profile?.supervisorsTitle
  )?.label;
  // const industryType = profileEditData?.industryCodes.find(
  //   x => x.value === profile?.industryType
  // )?.label;

  const memberShipTypeStudent = profile?.membershipType === 'STUDENT';

  const getGraduationDate = (_date: string) => {
    var formattedDate = _date ? format(parse(_date, 'M/d/y', new Date()), 'MMM dd, yyyy') : '';
    return formattedDate;
  };

  return (
    <ContainerCard className={styles.professionalContainer}>
      {profile && profileEditData ? (
        <>
          <div>
            <div className={styles.title}>Personal information</div>
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Name:</span>
              <span>
                {profile?.prefix} {profile?.firstName} {profile?.middleName} {profile?.lastName}{' '}
                {profile?.suffix}
              </span>
            </div>
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Preferred Name:</span>
              <span>{profile?.nickName}</span>
            </div>
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Birthday:</span>
              <span>
                {profile?.birthMonth} / {profile?.birthDay} / {profile?.birthYear}
              </span>
            </div>
            {/* <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Gender</span>
              <span>{gender}</span>
            </div> */}
            {/* <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Ethnicity</span>
              <span>{ethnicity}</span>
            </div> */}
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Sex:</span>
              <span>{genderSex}</span>
            </div>
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Race/Ethnicity:</span>
              <span>{raceEthnicity}</span>
            </div>
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Primary Language:</span>
              <span>{primaryLanguage}</span>
            </div>
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Highest Level of Education:</span>
              <span>{educationLevel}</span>
            </div>
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Student:</span>
              <span>{student}</span>
            </div>
          </div>
          <div className={styles.horizontalContainer}>
            <span className={styles.labelName}>HR Interest:</span>
            <div>
              {hrInterests &&
                hrInterests.map((e, i) => (
                  <span className={styles.optionsLabel}>
                    {e.label}
                    {hrInterests.length - 1 > i && ','}
                  </span>
                ))}
            </div>
          </div>
          <div className={styles.horizontalContainer}>
            <span className={styles.labelName}>Content Format Preference:</span>
            <div>
              {contentFormatPreferences &&
                contentFormatPreferences.map((e, i) => (
                  <span className={styles.optionsLabel}>
                    {e.label}
                    {contentFormatPreferences.length - 1 > i && ','}
                  </span>
                ))}
            </div>
          </div>
          <div className={styles.horizontalContainer}>
            <span className={styles.labelName}>Content Channel Preference:</span>
            <div>
              {contentChannelPreferences &&
                contentChannelPreferences.map((e, i) => (
                  <span className={styles.optionsLabel}>
                    {e.label}
                    {contentChannelPreferences.length - 1 > i && ','}
                  </span>
                ))}
            </div>
          </div>
          <div className={styles.horizontalContainer}>
            <span className={styles.labelName}>Secondary Email:</span>
            <span>{profile?.altEmail}</span>
          </div>
          <div className={styles.professionalInformation}>
            <div className={styles.title}>Professional information</div>
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Company Name:</span>
              <span>{profile?.companyName}</span>
            </div>
            {/* <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>HR Department Size</span>
              <span>{userDepartmentSize}</span>
            </div> */}
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Industry:</span>
              <span>{industry}</span>
            </div>
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Company Size:</span>
              <span>{companysize}</span>
            </div>
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Job Title:</span>
              <span>{profile?.jobTitle}</span>
            </div>
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Primary Job Function (Specialty):</span>
              <span>{jobfunctionPrimary}</span>
            </div>
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Secondary Job Function (Specialty):</span>
              <div>
                {jobfunctionSecondary &&
                  jobfunctionSecondary.map((e, i) => (
                    <span className={styles.optionsLabel}>
                      {e.label}
                      {jobfunctionSecondary.length - 1 > i && ','}
                    </span>
                  ))}
              </div>
            </div>

            {profile.gcrJobFunctionOthers && (
              <div className={styles.horizontalContainer}>
                <span className={styles.labelName}>Other Secondary Job Function:</span>
                <div>{profile.gcrJobFunctionOthers}</div>
              </div>
            )}
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Job Level:</span>
              <span>{joblevel}</span>
            </div>
            {/* archived <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Speciality:</span>
              <span>
                {profile?.specialtyCode === SPECIALTY_OTHER_CODE
                  ? profile?.specialtyOther
                  : userSpecialty}
              </span>
            </div> */}

            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Started Working in HR:</span>
              <span>{profile?.yearStartedHR}</span>
            </div>
            {/* <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Industry</span>
              <span>{industryType}</span>
            </div> */}
            <div className={styles.horizontalContainer}>
              <span className={styles.labelName}>Boss's Job Title:</span>
              <span>{supervisorsTitle}</span>
            </div>
          </div>
          {memberShipTypeStudent && (
            <div className={styles.education}>
              <div className={styles.title}>Education information</div>
              <div className={styles.horizontalContainer}>
                <span className={styles.labelName}>Major</span>
                <span>{academicMajor}</span>
              </div>
              <div className={styles.horizontalContainer}>
                <span className={styles.labelName}>School</span>
                <span>{profile.university}</span>
              </div>
              <div className={styles.horizontalContainer}>
                <span className={styles.labelName}>Graduation</span>
                <span>{getGraduationDate(profile.graduationDate)}</span>
              </div>
              <div className={styles.horizontalContainer}>
                <span className={styles.labelName}>Degree</span>
                <span>{enrollmentStatus}</span>
              </div>
              <div className={styles.horizontalContainer}>
                <span className={styles.labelName}>Credits</span>
                <span>
                  {profile.numberCredits} per {creditTerm}
                </span>
              </div>
            </div>
          )}
          {profile?.chapterId && (
            <div className={styles.chapterAffiliation}>
              <div className={styles.title}>Chapter affiliation</div>
              <div className={styles.horizontalContainer}>
                <span className={styles.labelName}>Chapter</span>
                <span className={styles.spanValueLink}>
                  <a href={profile?.chapterWebAddress} target='_blank'>
                    {profile?.chapterName}
                  </a>
                </span>
              </div>
            </div>
          )}
          <div className={styles.footerLine}>
            <button className={styles.buttonEdit} onClick={props.toggleEditMode}>
              Edit
            </button>
          </div>
        </>
      ) : (
        <div>There is no profile data.</div>
      )}
    </ContainerCard>
  );
};
export default ProfileReadMode;
